/**
 * dongju模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../assets/http.js'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const dongjuapi = {
  // Cart
  // 加入购物车
  cart(params) {
    return axios.post(`${base.sq}/cart`, qs.stringify(params));
  },
  // 移除购物车商品
  delete_carts(params) {
    return axios.delete(`${base.sq}/cart`, {
      params: params
    })
  },
  // 获取购物车
  get_carts(params) {
    return axios.get(`${base.sq}/carts`, {
      params: params
    });
  },

  // Index
  // 下载列表
  downloads(params) {
    return axios.get(`${base.sq}/downloads`, {
      params: params
    });
  },
  // 产品列表
  products(params) {
    return axios.get(`${base.sq}/products`, {
      params: params
    });
  },
  // 产品类型列表/下载中心分类列表
  categories(lang) {
    return axios.get(`${base.sq}/categories/${lang}`);
  },
  // 产品详情
  productDetails(id, lang) {
    return axios.get(`${base.sq}/product/${id}/${lang}`, {
      uuid: id,
      lang: lang
    });
  },
  // 经销商列表及其详情
  distributors(lang) {
    return axios.get(`${base.sq}/distributors/${lang}`);
  },
  // 获取banner列表
  banner(params) {
    return axios.get(`${base.sq}/banner`, {
      params: params
    });
  },
  // 获取首页的客服、banner、产品、视频等数据列表
  index(lang, params) {
    return axios.get(`${base.sq}/index/${lang}`, {
      params: params
    });
  },
  // 获取公司地址相关信息
  getAddress(params){
    return axios.get(`${base.sq}/address`, {
      params: params
    });
  },
  // 视频列表
  videos(lang, params) {
    return axios.get(`${base.sq}/videos/${lang}`, {
      params: params
    });
  },
  // 获取产品规格详情
  specification(params) {
    return axios.get(`${base.sq}/specification/detail`, {
      params: params
    });
  },
  // 下载分类列表及其详情
  category(lang) {
    return axios.get(`${base.sq}/software/category/${lang}`);
  },
  // 软件和其他文件下载列表
  software(params){
    return axios.get(`${base.sq}/software`, {
      params: params
    });
  },
	// 资料访问量和下载量新增
	count(params){
	  return axios.get(`${base.sq}/downloads/count`, {
	    params: params
	  });
	},

  // Member
  // 用户注册
  register(params) {
    return axios.post(`${base.sq}/register`, qs.stringify(params));
  },
  // 登录校验，并返回token
  login(params) {
    return axios.post(`${base.sq}/login`, qs.stringify(params));
  },
  // 获取当前登录会员信息
  member() {
    return axios.get(`${base.sq}/member`, {});
  },

  // MemberAddress
  // 删除用户地址
  addressDetele(id, params) {
    return axios.delete(`${base.sq}/member/address/${id}`, {
      params: params
    })
  },
  // 添加用户地址
  address(params) {
    return axios.post(`${base.sq}/member/address`, qs.stringify(params));
  },
  // 用户地址详情
  addressDetails(id, params) {
    return axios.get(`${base.sq}/member/address/${id}`, {
      params: params
    })
  },
  // 编辑用户地址
  addressUpdate(params) {
    return axios.patch(`${base.sq}/member/address`, qs.stringify(params));
  },
  // 获取用户地址列表
  addressList() {
    return axios.get(`${base.sq}/member/addresses`);
  },

  // Order
  // 删除订单
  delete_order(params) {
    return axios.delete(`${base.sq}/order`, {
      params: params
    })
  },
  // 生成或者更新开票信息
  invoice() {
    return axios.post(`${base.sq}/invoice`);
  },
  // 生成订单
  get_order(params) {
    return axios.post(`${base.sq}/order`, qs.stringify(params));
  },
  // 完成订单
  received(no) {
    return axios.patch(`${base.sq}/order/received/${no}`)
  },
  // 获取线下打款配置参数
  get_offline(no) {
    return axios.get(`${base.sq}/offline/${no}`);
  },
  // 获取订单列表
  orders(params) {
    return axios.get(`${base.sq}/orders`, {
      params: params
    });
  },
  // 获取订单合同
  order_contract(params) {
    return axios.get(`${base.sq}/order/contract`, {
      params: params
    });
  },
  // 获取该用户的开票信息
  get_invoice() {
    return axios.get(`${base.sq}/invoice`);
  },
  // Pay
  // 微信支付
  pay_wechat(no) {
    return axios.get(`${base.sq}/payment/${no}/wechat`);
  },
  // 支付宝支付
  pay_alipay(no) {
    return axios.get(`${base.sq}/payment/${no}/alipay`);
  },
}

export default dongjuapi;
